import type { ArtefactType } from '../lib/artefact-type'
import { IconDeck } from './NavIcons'

/**
 * The artefact type's glyph — ONE source for the explorer rows (LeftNav) and the "New artefact"
 * dialog's type radios and template tree (AB#270), so the three always show the same icon.
 * Decorative: the caller owns the accessible name (and hides this from AT where it repeats it).
 */
export function ArtefactTypeGlyph({ type }: { type: ArtefactType }) {
  if (type === 'slides') return <IconDeck />
  if (type === 'grid') return <>▦</>
  return <>📄</>
}
